// @ts-ignore
export const all = (state) => state.all;
// @ts-ignore
export const isAllLoaded = (state) => state.loadAll;
